// extracted by mini-css-extract-plugin
module.exports = {"scroll__animation":"animations_scroll__animation__Neguz","active":"animations_active__dW3pQ"};